import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from "../../../../shared/services/auth.service";
import {Observable, Subscription, switchMap} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {SnackbarService} from "../../../../shared/services/snackbar.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatButton, MatIconButton} from "@angular/material/button";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {ActivatedRoute, RouterLink, RouterOutlet} from "@angular/router";
import {MatListItem, MatNavList} from "@angular/material/list";
import {MatIcon} from "@angular/material/icon";
import {DialogConfirmComponent} from "../../../../shared/components/dialogs/dialog-confirm/dialog-confirm.component";
import {MatDialog} from "@angular/material/dialog";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";

@Component({
  selector: 'app-page-list-admin',
  standalone: true,
  imports: [
    MatButton,
    CardsBasicComponent,
    RouterOutlet,
    RouterLink,
    MatListItem,
    MatNavList,
    MatIcon,
    MatIconButton,
    LocalizeRouterPipe,
    TranslateModule
  ],
  templateUrl: './page-list-admin.component.html',
  styleUrl: './page-list-admin.component.css'
})
export class PageListAdminComponent implements OnInit, OnDestroy {
  productId!: any;
  pageList: any[] = [];
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _snackbarService: SnackbarService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    public _authService: AuthService,
    public _route: ActivatedRoute,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.setupLanguageSubscription();
    this.getRouteParams();
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private getRouteParams(): void {
    this._route.params.subscribe(params => {
      this.productId = this._route.snapshot.parent?.params['productId'];
      this.loadPageList();
    });
  }


  private loadPageList(): void {
    this.subscriptions.add(
      this._apiService.fetchPageList(this.productId).subscribe({
        next: (response: any) => {
          this.pageList = response;
          console.log('pagelist', this.pageList);
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }


  confirmDelete(pageId: number, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    DialogConfirmComponent.openDeleteDialog(this._dialog, this._translate).subscribe(result => {
      if (result) {
        this.deletePage(pageId);
      }
    });
  }

  private deletePage(pageId: number): void {
    this.subscriptions.add(
      this._apiService.deletePage(pageId).subscribe({
        next: (response: any) => {
          this.loadPageList();
          this._snackbarService.show(response.message);
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


}
